import { render, staticRenderFns } from "./accountManager.vue?vue&type=template&id=1c2de521&scoped=true"
import script from "./accountManager.vue?vue&type=script&lang=js"
export * from "./accountManager.vue?vue&type=script&lang=js"
import style0 from "./accountManager.vue?vue&type=style&index=0&id=1c2de521&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2de521",
  null
  
)

export default component.exports